(function () {
  const dataEl = document.getElementById('variant-gallery-data');
  const galleryData = dataEl ? JSON.parse(dataEl.textContent) : {};

  function buildSlide(url, variantId, index) {
    const slide = document.createElement('slideshow-slide');
    slide.setAttribute('data-metafield-image', 'true');
    slide.setAttribute('data-variant-id', String(variantId));
    slide.setAttribute('aria-hidden', 'true');
    slide.style.cssText = `--slideshow-timeline: --slide-meta-${index}; --product-media-fit: cover;`;
    slide.innerHTML = `
      <div class="product-media-container product-media-container--image media-fit-cover">
        <div class="product-media">
          <img
            src="${url}"
            alt="Imagem ${index + 1}"
            style="width:100%;height:100%;object-fit:cover;display:block;"
            loading="lazy"
          >
        </div>
      </div>`;
    return slide;
  }

  function reinitSlideshow(slideshowComponent) {
    // Força o custom element a se reconectar, reiniciando o IntersectionObserver
    const parent = slideshowComponent.parentNode;
    const next = slideshowComponent.nextSibling;
    parent.removeChild(slideshowComponent);
    parent.insertBefore(slideshowComponent, next);
  }

  function injectMetafieldImages(variantId) {
    const images = galleryData[String(variantId)] || [];

    // Remove slides injetados anteriormente
    document.querySelectorAll('[data-metafield-image]').forEach(el => el.remove());

    if (images.length === 0) return;

    const scroller = document.querySelector('media-gallery slideshow-slides');
    if (!scroller) return;

    images.forEach((url, i) => {
      scroller.appendChild(buildSlide(url, variantId, i));
    });

    // Reinicia o slideshow para reconhecer os novos slides
    const slideshowComponent = document.querySelector('media-gallery slideshow-component');
    if (slideshowComponent) {
      setTimeout(() => reinitSlideshow(slideshowComponent), 50);
    }
  }

  function filterGallery(variantId) {
    // Filtra slides nativos por variante
    document.querySelectorAll('slideshow-slide[data-variant-id]:not([data-metafield-image])').forEach((slide) => {
      const id = slide.dataset.variantId;
      slide.style.display = (!id || id === '' || id === String(variantId)) ? '' : 'none';
    });

    // Grid items
    document.querySelectorAll('li[data-variant-id]').forEach((item) => {
      const id = item.dataset.variantId;
      item.style.display = (!id || id === '' || id === String(variantId)) ? '' : 'none';
    });

    injectMetafieldImages(variantId);
  }

  document.addEventListener('on:variant:change', (e) => {
    const variantId = e.detail?.variant?.id;
    if (variantId) filterGallery(variantId);
  });

  function init() {
    const input = document.querySelector('input[name="id"]');
    if (input?.value) filterGallery(input.value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 300);
  }
})();
